@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use './cycle' as *;
@use './dot' as *;

@layer kol-component {
	.kol-spin {
		&__spinner {
			display: block;
			position: relative;
		}
	}
}
